<template>
  <CRow>
    <CCol lg="12">
      <CCard v-if="createBill">
        <CCardHeader>
          <CRow v-if="createBill" class="ml-1">
            <CButton class="mr-2" @click="selectAllBill" color="light">
              <CIcon name="cil-check-alt" class="mr-2"/>Chọn tất cả</CButton>
            <CButton class="mr-2" @click="deselectAllBill" color="light">
              <CIcon name="cil-x" class="mr-2" />Bỏ chọn tất cả</CButton>
            <CButton class="mr-2" @click="deleteMemorySelected" color="light">
              <CIcon name="cil-trash" class="mr-2"/>Bỏ mục đã chọn</CButton>
            <CButton :disabled="billRecords.length <= 0" class="mr-2" @click="exportFile" color="light">
              <CIcon name="cil-cloud-download" class="mr-2"/>Xuất danh mục linh kiện</CButton>

            <CAlert
              :show.sync="dismissCountDown"
              color="success"
              fade
              class="pb-0 mb-1 pt-0 mt-2"
            >
              {{alertMessage}}!
            </CAlert>

            <div class="ml-auto">
              <CButton color='warning'>
                {{ billType === 'import' ? 'Đang tạo danh mục Nhập kho' : 'Đang tạo danh mục Xuất kho' }}
              </CButton>
            </div>
          </CRow>
        </CCardHeader>
        <CCardBody>
          <CDataTable
            :items="formattedBillRecords"
            :fields="billHeaders"
            :key="tableBillKey"
            sorter
            pagination
          >
            <template #no-items-view>
              <div style="color: #888; text-align: center; padding: 10px; font-style: italic;">
                Danh sách trống!
              </div>
            </template>

            <template #selection="{item, index}">
              <td>
                <div class="action-column">
                  <input type="checkbox"
                         v-model="item.selection"
                         class="checkbox mt-2"/>
                </div>
              </td>
            </template>

            <template #SL="{item, index}">
              <td class="text-right">
                {{ item.SL }}
              </td>
            </template>
            <template #stock_qty="{item, index}">
              <td class="text-right">
                {{ item.stock_qty }}
              </td>
            </template>
            <template #reserved_qty="{item, index}">
              <td class="text-right">
                {{ item.reserved_qty }}
              </td>
            </template>
            <template #available_qty="{item, index}">
              <td class="text-right">
                {{ item.available_qty }}
              </td>
            </template>

          </CDataTable>
        </CCardBody>
      </CCard>
      <CCard>
        <CCardHeader class="pb-0 mb-0">
          <CRow>
            <CCol md="12" lg="6" xl="3" xxl="3">
              <!--<CSelect  :options="options"  :value.sync="criteria.component"/>-->
              <v-select
                v-model="selectedOption"
                :options="options"
                @input="onInputChange"
                placeholder="Lựa chọn"
              />
            </CCol>
            <CCol md="12" lg="6" xl="5" xxl="5">
              <CInput  placeholder="Nội dung tìm kiếm"  v-model="criteria.criteria" @keyup.enter="searchElements"/>
            </CCol>

            <CCol md="6" lg="6" xl="2" xxl="2"  class="mb-2 mb-xl-0">
              <CButton color="info" shape="pill" block
                       @click="searchElements">
                <CIcon name="cil-magnifying-glass"/>Tìm kiếm</CButton>
            </CCol>
            <CCol v-if="isSuper" md="6" lg="6" xl="2" xxl="2" class="mb-2 mb-xl-0">
              <CButton :disabled="criteria.component==='all'"
                color="info" shape="pill" block
                @click="createElement">
                <CIcon name="cil-plus"/>Tạo mới</CButton>
            </CCol>

          </CRow>
          <CRow v-if="createBill" class="ml-1 mt-0 mb-2 pt-0 pb-2">
            <CButton class="mr-2" @click="selectAll" color="light">
              <CIcon name="cil-check-alt" class="mr-2"/>Chọn tất cả</CButton>
            <CButton class="mr-2" @click="deselectAll" color="light">
              <CIcon name="cil-x" class="mr-2" />Bỏ chọn tất cả</CButton>
            <CButton class="mr-2" @click="saveMemory" color="light">
              <CIcon name="cil-save" class="mr-2"/>Thêm/cập nhật mục đã chọn</CButton>
          </CRow>
        </CCardHeader>
        <CCardBody class="pt-1">
          <div>
            <p v-if="records && records.length > 0" class="pb-0 mb-0">Số lượng: {{ records.length }}</p>
            <CDataTable
              :items="formattedRecords"
              :fields="visibleHeaders"
              :tableFilter="{label :'Bộ lọc: ', placeholder:'Nội dung' }"
              :itemsPerPageSelect="{label:' '}"
              column-filter
              :key="tableKey"
              sorter
              pagination
            >
              <template #no-items-view>
                <div style="color: #888; text-align: center; padding: 10px; font-style: italic;">
                  Danh sách trống!
                </div>
              </template>

              <template #Image="{item, index}">
                <td class="py-1">
                  <CCol class="justify-content-center">
                    <img v-if="item['Link hình ảnh'] && item['Link hình ảnh'].length > 2"
                         :src="item['Link hình ảnh']" alt="Ảnh"
                         style="width: 40px; height: 40px; margin-right: 0px; margin-bottom: 2px;"
                         @mouseover="showImage(item['Link hình ảnh'])"
                         @mouseleave="hideImage"/>
                    <a v-if="item['Link tài liệu'] && item['Link tài liệu'].length > 2"
                       :title="records[index]['Link tài liệu']"
                       :href="records[index]['Link tài liệu']"
                       style="color: inherit; text-decoration: none;"
                       target="_blank" rel="noopener noreferrer">
                      <CIcon name="cil-description" size="lg" style="width: 25px; height: 25px"/></a>
                  </CCol>
                </td>
              </template>

              <template #Mã="{item, index}">
                <td>
                  <a href="#" @click="rowClicked(item, index)">{{ item['Mã']}}</a>
                </td>
              </template>

              <template #actions="{item, index}">
                <td>
                  <CDropdown
                    size="lg"
                    :caret="false"
                    placement="bottom-end">
                    <template #toggler>
                      <CButton variant="ghost">
                        <CIcon name="cil-list" size="lg"/>
                      </CButton>
                    </template>

                    <CDropdownItem @click="showInputRepository(item, index)">
                      <CIcon name="cil-input" class="mr-2"/>Cập nhật</CDropdownItem>
                    <CDropdownItem @click="showHistory(item, index)">
                      <CIcon name="cil-history" class="mr-2"/>Lịch sử</CDropdownItem>
                    <!--<CDropdownItem @click="showHistoryImport(item, index)">-->
                    <!--  <CIcon name="cil-history" class="mr-2"/>Lịch sử nhập kho</CDropdownItem>-->
                    <!--<CDropdownItem @click="showHistoryExport(item, index)">-->
                    <!--  <CIcon name="cil-history" class="mr-2"/>Lịch sử xuất kho</CDropdownItem>-->
                    <!--<CDropdownItem @click="showHistoryEdit(item, index)">-->
                    <!--  <CIcon name="cil-history" class="mr-2"/>Lịch sử chỉnh sửa</CDropdownItem>-->

                  </CDropdown>
                </td>
              </template>

              <template #SL="{item, index}">
                <td>
                  <div class="action-column">
                    <input type="text"
                           class="qty-input"
                           :key="`sl-${item._index}`"
                           v-model="inputQuantityValues[item._index]"
                           @input="handleQuantityInput(records[item._index], item._index, $event)"
                           @blur="handleQuantityBlur(records[item._index], item._index, $event)"
                           @focus="handleQuantityFocus($event)"/>
                  </div>
                </td>
              </template>

              <template #Location="{item, index}">
                <td>
                  <CSelect
                    :options="getFilteredLocationOptions(records[item._index])"
                    :value.sync="records[item._index].Location"
                    :placeholder="'Chọn vị trí (SL: ' + getMaxQuantityForLocation(records[item._index], records[item._index].Location) + ')'"
                  />
                </td>
              </template>

            </CDataTable>
          </div>
        </CCardBody>
      </CCard>
    </CCol>

    <div v-if="hoveredImage" class="image-preview">
      <img :src="hoveredImage" class="preview-image" />
    </div>

    <CModal
      :show.sync="darkModal"
      :no-close-on-backdrop="true"
      title="Modal title 2"
      color="info"
      :centered="true"
    >
      <CRow class="m-0 p-0 pb-3">
        <CCol class="d-flex justify-content-center align-items-center">
          EES CODE: <strong>{{ecodeIndex}}</strong></CCol>
      </CRow>
      <CSelect
        label="Loại thao tác:"
        :options="operationTypes"
        :value.sync="params.operationType"
        :addLabelClasses="'text-right'"
        :horizontal="{ label: 'col-sm-4', input: 'col-sm-8'}"
      />
      <CInput label="Số lượng tồn:" :value="formatNumber(stockIndex) +': ' + locationIndex" readonly
              :addLabelClasses="'text-right'"
              :horizontal="{ label: 'col-sm-4', input: 'col-sm-8'}" />
      <CInput label="Số lượng:" type="text"
              v-model="modalQuantityFormatted"
              @focus="handleModalQuantityFocus"
              :addLabelClasses="'text-right'"
              :horizontal="{ label: 'col-sm-4', input: 'col-sm-8'}" />
      <CSelect v-if="params.operationType === 'move'"
               label="Kho nguồn:"
               :options="locationOptions"
               :value.sync="params.sourceLocation"
               :addLabelClasses="'text-right'"
               :horizontal="{ label: 'col-sm-4', input: 'col-sm-8'}" />
      <CSelect
               label="Kho đích:"
               :options="locationOptions"
               :value.sync="params.destLocation"
               :addLabelClasses="'text-right'"
               :horizontal="{ label: 'col-sm-4', input: 'col-sm-8'}" />
      <CInput
               label="Ngày thực hiện:"
               type="date"
               v-model="params.date"
               :addLabelClasses="'text-right'"
               :horizontal="{ label: 'col-sm-4', input: 'col-sm-8'}" />
      <template #header>
        <strong v-if="selectedIndex !== -1 && records[selectedIndex]" class="modal-title">
          Nhập linh kiện: {{records[selectedIndex]['Mã']}}</strong>
        <CButtonClose @click="darkModal = false" class="text-white"/>
      </template>
      <template #footer>
        <CButton color="info"
          @click="handleOperation">
          <CIcon name="cil-save" class="mr-2" />{{ params.operationType === 'move' ? 'Di chuyển' :
          (params.operationType === 'update' ? 'Cập nhật' : 'Nhập') }}</CButton>
        <CButton @click="darkModal = false" color="secondary"><CIcon name="cil-x" class="mr-2" />Đóng</CButton>
      </template>
    </CModal>

  </CRow>

  </template>

<script>
import 'vue-select/dist/vue-select.css'
import vSelect from 'vue-select'

export default {
  components: {
    vSelect,
  },
  data () {
    return {
      options: [{ label: "Tất cả", value: "all" },],
      headers_all: [
        { key: 'SL', label: 'Số lượng', _style: 'width: 6rem; text-align: right;'},
        { key: 'Image', label: 'Ảnh / Tài liệu'},
        { key: 'EES CODE', label: 'Mã EES'},
        { key: 'Mô tả',  label: 'Mô tả'},
        { key: 'Mã', label: 'Mã NSX'},
        { key: 'location_formatted', label: 'Vị trí'},
        { key: 'Location', label: 'Chọn vị trí'},
        { key: 'stock_qty', label: 'Tồn', _classes: 'text-right'},
        { key: 'reserved_qty', label: ' Đặt trước', _classes: 'text-right'},
        { key: 'available_qty', label: 'Khả dụng', _classes: 'text-right'},
        { key: 'Ghi chú', label: 'Ghi chú'},
        { key: 'actions', label: 'Thao tác'},
      ],
      headers: [
        { key: 'Image', label: 'Ảnh/Tài liệu'},
        { key: 'EES CODE', label: 'Mã EES'},
        { key: 'Mô tả',  label: 'Mô tả'},
        { key: 'Mã', label: 'Mã NSX'},
        { key: 'NSX', label: 'NSX', _style:'width: 10rem;'},
        { key: 'location_formatted', label: 'Vị trí kho'},
        { key: 'stock_qty', label: 'Lượng tồn', _classes: 'text-right'},
        { key: 'reserved_qty', label: ' Đặt trước', _classes: 'text-right'},
        { key: 'available_qty', label: 'Khả dụng', _classes: 'text-right'},
        { key: 'Ghi chú', label: 'Ghi chú'},
        { key: 'actions', label: 'Thao tác'},
      ],
      records: [],
      criteria: {
        component: 'all',
        criteria: '',
      },
      params: {
        component: '',
        part: '',
        quantity: 1,
        destLocation: '',
        sourceLocation: '',
        operationType: 'import',
        date: new Date().toISOString().split('T')[0],
      },
      operationTypes: [
        { label: 'Nhập kho', value: 'import' },
        { label: 'Di chuyển', value: 'move' },
        { label: 'Cập nhật số lượng', value: 'update' }
      ],
      locationOptions: [],
      tableKey: 0,
      tableBillKey: 0,
      isSuper: false,
      isSearchAll: true,
      currentImage: '',
      searched: false,
      hoveredImage: null,
      darkModal: false,
      selectedIndex: -1,
      stockIndex: -1,
      locationIndex: '',
      ecodeIndex: '',
      createBill: false,
      billHeaders: [
        { key: 'selection', label: 'Chọn', _style: 'width: 3rem;'},
        { key: 'Nhóm linh kiện', label: 'Nhóm linh kiện'},
        { key: 'EES CODE', label: 'Mã EES'},
        { key: 'Mô tả',  label: 'Mô tả'},
        { key: 'Mã', label: 'Mã NSX'},
        { key: 'NSX', label: 'NSX'},
        { key: 'SL', label: 'Số lượng'},
        { key: 'Location', label: 'Vị trí'},
      ],
      billRecords: [],
      dismissCountDown: 0,
      alertMessage: '',
      selectedOption: null,
      modalQuantityFormatted: '1',
      inputQuantityValues: {},
      billType: 'import',
    }
  },
  created() {
    this.getSuper()
    this.getTypes()
    this.getLocations()
    if(this.$route.query.searched) {
      this.criteria.component = this.$route.query.component
      this.criteria.criteria = this.$route.query.criteria
      this.searchElements()
    }
    if(this.$route.query.request) {
      this.createBill=true
      if(this.$route.query.request === 'import') {
        this.billType='import'
      } else if(this.$route.query.request === 'export') {
        this.billType='export'
      }
    }
    // Handle bill type parameter (import or export)
    if(this.$route.query.type) {
      this.billType = this.$route.query.type;
    }
  },
  computed: {
    visibleHeaders() {
      if (this.createBill) {
        return this.headers_all;
      }
      return this.headers
    },
    formattedRecords() {
      return this.records.map((item, index) => {
        return {
          ...item,
          _index: index,
          SL_display: this.formatNumber(item.SL),
          location_formatted: this.formatLocationWithQuantity(item['Vị trí']),
          stock_qty: this.formatNumber(item['Số lượng tồn']),
          reserved_qty: this.formatNumber(item['Số lượng đặt trước']),
          available_qty: this.formatNumber(item['Số lượng khả dụng'])
        }
      })
    },
    formattedBillRecords() {
      return this.billRecords.map((item, index) => {
        return {
          ...item,
          _index: index,
          SL: this.formatNumber(item.SL),
          stock_qty: this.formatNumber(item['Số lượng tồn']),
          reserved_qty: this.formatNumber(item['Số lượng đặt trước']),
          available_qty: this.formatNumber(item['Số lượng khả dụng'])
        }
      })
    }
  },
  methods: {
    getSuper() {
      const role = localStorage.getItem('role')
      this.isSuper = ((role === 'root') || (role === 'super'))
    },
    getTypes() {
      this.$request.get(
        '/api/repo/search').
      then(res => {
        var apiOptions=[]
        if(res.data.types) {
           apiOptions = res.data.types.map(item => ({
            label: item['label'],
            value: item['name'],
          }));
        }

        // Prepend a predefined option
        const predefinedOption = { label: "Tất cả", value: "all" };
        apiOptions.unshift(predefinedOption);
        this.options = apiOptions
        // console.log(this.options);
        if(this.$route.query.searched) {
          let index = this.options.findIndex(item => item.value === this.$route.query.component);
          if (index > -1 && this.options.length > index) {
            this.selectedOption=this.options[index]
            // console.log('set selectedOption', this.selectedOption)
          }
        }
      })
    },
    getLocations() {
      this.$request.get('/api/repo/locations').then(res => {
        if(res.data.locations && res.data.locations.length > 0) {
          this.locationOptions = res.data.locations.map(loc => {
            return typeof loc === 'object' ? loc.name : loc;
          });
        }
      }).catch(error => {
        console.log('Load locations error, using default list');
      })
    },
    searchElements() {
      this.records = []
      this.searched = true
      this.isSearchAll = this.criteria.component === 'all'
      // console.log(this.criteria.component, this.isSearchAll)
      this.$request.post(`/api/repo/search`, this.criteria).
      then((res) => {
        if(res.data.status === 'success') {
          this.records = res.data.records;
          // Initialize inputQuantityValues
          this.inputQuantityValues = {};
          this.records.forEach((item, index) => {
            this.$set(this.inputQuantityValues, index, this.formatNumber(item.SL || 0));
          });
          // console.log(this.records)
          // Initialize Location to first option if not set
          // this.records.forEach(item => {
          //   if (!item.Location && this.locationOptions.length > 0) {
          //     item.Location = this.locationOptions[0];
          //   }
          // });
        }
        // console.log('records: ', this.records);
      });
      // console.log(this.criteria);
    },
    createElement() {
      //// console.log('request create element', this.criteria);
      if(this.criteria.component === 'all') {
        return
      }

      this.$router.push({
        path: '/component/mod',
        query: {
          component: this.criteria.component,
          part: null,
          searched: true,
        }
      });
    },
    editElement(item) {
      this.$router.push({
        path: '/component/mod',
        query: {
          component: item['Nhóm linh kiện'],
          criteria: this.criteria.criteria,
          part: item['Mã'],
          searched: true,
        }
      });
    },
    rowClicked (item, index) {
      this.editElement(item)
    },
    searchOn(name) {
      /*// console.log('request search on', name)*/
      this.criteria.component=name
      this.searchElements()
    },
    documentClicked(item, index) {
      /*// console.log('document clicked', item, index)*/
    },
    showImage(image) {
      this.hoveredImage = image;
    },
    hideImage() {
      this.hoveredImage = null;
    },
    showHistoryImport(item, index) {
      // console.log('showHistoryImp: ', item, index);
      this.$router.push({
        path: '/component/history',
        query: {
          action: 'import',
          part: item['Mã'],
          component: item['Nhóm linh kiện'],
          criteria: this.criteria.criteria,
          searched: this.searched,
        }
      })
    },
    showHistoryExport(item, index) {
      // console.log('showHistoryExport: ', item, index);
      this.$router.push({
        path: '/component/history',
        query: {
          action: 'export',
          part: item['Mã'],
          component: item['Nhóm linh kiện'],
          criteria: this.criteria.criteria,
          searched: this.searched,
        }
      })
    },
    showHistory(item, index) {
      // console.log('showHistoryExport: ', item, index);
      this.$router.push({
        path: '/component/history',
        query: {
          part: item['Mã'],
          component: item['Nhóm linh kiện'],
          criteria: this.criteria.criteria,
          searched: this.searched,
        }
      })
    },
    showHistoryEdit(item, index) {
      // console.log('showHistoryEdi: ', item, index);
      this.$router.push({
        path: '/component/history',
        query: {
          action: 'edit',
          part: item['Mã'],
          component: item['Nhóm linh kiện'],
          criteria: this.criteria.criteria,
          searched: this.searched,
        }
      })
    },
    showReserve(item, index) {
      // console.log('showReserve', item, index);
      this.$router.push({
        path: '/component/history',
        query: {
          action: 'reserve',
          part: item['Mã'],
          component: item['Nhóm linh kiện'],
          criteria: this.criteria.criteria,
          searched: this.searched,
        }
      })
    },
    showInputRepository(item, index) {
      // console.log('showInputRepository: ', item, index);
      this.params.component = item['Nhóm linh kiện']
      this.params.part = item['Mã'];
      this.params.operationType = 'import';
      this.params.sourceLocation = '';
      this.params.quantity = 1;
      this.modalQuantityFormatted = '1';
      this.getComponent(this.params)
      this.darkModal=true;
      this.selectedIndex = index;
    },
    getComponent(params) {
      // console.log('do request with params: ', params)
      this.$request.get(`/api/repo/mod`, {params}).
      then(res => {
        if(res.data.headers) {
          // console.log(res.data.values);
          let indexStock = res.data.headers.findIndex(item => item.label.includes("Số lượng tồn"));
          let indexLocation = res.data.headers.findIndex(item => item.label.includes("Vị trí"));
          let indexCode = res.data.headers.findIndex(item => item.label.includes("EES CODE"));
          this.locationIndex = res.data.values[indexLocation];
          this.stockIndex = res.data.values[indexStock]
          this.params.destLocation = this.locationOptions.length > 0 ? this.locationOptions[0] : ''
          this.params.sourceLocation = this.locationOptions.length > 0 ? this.locationOptions[0] : ''
          this.ecodeIndex = res.data.values[indexCode]
        } else {
          // console.log('response invalid: ', res.data)
        }
      })
    },
    handleOperation() {
      if (this.params.operationType === 'move') {
        this.moveQuantityLocation();
      } else {
        this.addQuantityLocation();
      }
    },
    addQuantityLocation(){
      // console.log('addQuantityLocation', JSON.parse(JSON.stringify(this.params)));
      // console.log('quantity value:', this.params.quantity, 'type:', typeof this.params.quantity);
      if (!this.params.destLocation) {
        this.$swal.fire({
          icon: "error",
          title: this.params.operationType === 'update' ? "Cập nhật số lượng" : "Nhập kho",
          text: "Vui lòng chọn kho đích",
        });
        return;
      }

      this.darkModal=false;
      this.selectedIndex = -1;

      this.$request.post(`/api/repo/updatequanloc`, this.params).then(res=>{
        // console.log(res.data);
        if(res.data.status === 'success'){
          const isUpdate = this.params.operationType === 'update';
          this.$swal.fire({
            icon: "success",
            title: isUpdate ? "Cập nhật số lượng" : "Nhập kho",
            text: (isUpdate ? "Cập nhật số lượng: " : "Nhập kho: ") + this.params.part +
                  (isUpdate ? " tại " + this.params.destLocation : "") + " thành công" ,
          }).then(() => {
            this.params.quantity=1
            this.searchElements()
          });
        } else {
          this.$swal.fire({
            icon: "error",
            title: this.params.operationType === 'update' ? "Cập nhật số lượng" : "Nhập kho",
            text: (this.params.operationType === 'update' ? "Cập nhật số lượng lỗi: " : "Nhập kho lỗi: ") +
                  this.params.part + " lỗi: " + res.data.status,
          });
        }
      })
    },
    moveQuantityLocation() {
      // console.log('moveQuantityLocation params:', JSON.parse(JSON.stringify(this.params)));
      // console.log('sourceLocation:', this.params.sourceLocation, 'destLocation:', this.params.destLocation);

      if (!this.params.sourceLocation || !this.params.destLocation) {
        this.$swal.fire({
          icon: "error",
          title: "Di chuyển kho",
          text: "Vui lòng nhập đầy đủ kho nguồn và kho đích",
        });
        return;
      }

      this.darkModal=false;
      this.selectedIndex = -1;

      this.$request.post(`/api/repo/movequanloc`, this.params).then(res=>{
        if(res.data.status === 'success'){
          this.$swal.fire({
            icon: "success",
            title: "Di chuyển kho",
            text: "Di chuyển: " + this.params.part + " từ " + this.params.sourceLocation + " sang " + this.params.destLocation + " thành công" ,
          }).then(() => {
            this.params.quantity=1
            this.params.sourceLocation=''
            this.searchElements()
          });
        } else {
          this.$swal.fire({
            icon: "error",
            title: "Di chuyển kho",
            text: "Di chuyển kho lỗi: " + this.params.part +
              " lỗi: " + res.data.status,
          });
        }
      })
    },
    selectAll() {
      this.tableKey++
      // console.log('selectAll')
      this.records.forEach(item => {
        item['SL'] = 100;
      });
    },
    selectAllBill() {
      this.tableBillKey++
      // console.log('selectAllBill')
      this.billRecords.forEach(item => {
        item.selection = true;
      });
    },
    deselectAll() {
      this.tableKey++
      // console.log('deselectAll')
      this.records.forEach(item => {
        item['SL'] = 0;
      });
    },
    deselectAllBill() {
      this.tableBillKey++
      // console.log('deselectAll')
      this.billRecords.forEach(item => {
        item.selection = false;
      });
    },
    saveMemory() {
      const selectedItems = this.records.filter(item => Number(item['SL']) > 0);
      // console.log('saveMemory', selectedItems.length)
      if (selectedItems.length > 0) {
        // Validate each item before saving
        for (let item of selectedItems) {
          const validation = this.validateMemoryItem(item);
          if (!validation.valid) {
            this.$swal.fire({
              icon: "error",
              title: "Thao tác lỗi",
              html: `<strong>${item['Mã']}</strong><br/>${validation.message}`,
            });
            return;
          }
        }

        this.$request.post(`/api/repo/addmemory`, selectedItems).then(res=>{
          if(res.data.status === 'success'){
            this.billRecords = res.data.bill_data;
            this.showAlertMessage(3, 'Thêm/cập nhật mục linh kiện thành công')
          }
        })
      }
    },
    validateMemoryItem(item) {

      if (this.billType === 'import') {
        return { valid: true };
      }

      // Validate Location selection
      if (!item.Location) {
        return {
          valid: false,
          message: 'Vui lòng chọn vị trí linh kiện'
        };
      }

      // Get available locations from location_formatted
      const availableLocations = this.getAvailableLocationsFromFormatted(item['Vị trí']);

      // Check if selected location exists in available locations
      if (!availableLocations.some(loc => loc.name === item.Location)) {
        return {
          valid: false,
          message: `Vị trí "${item.Location}" không có trong kho. Vị trí có sẵn: ${availableLocations.map(l => l.name).join(', ')}`
        };
      }

      // Find the location and check quantity limit
      const selectedLocation = availableLocations.find(loc => loc.name === item.Location);
      if (selectedLocation && Number(item['SL']) > selectedLocation.quantity) {
        return {
          valid: false,
          message: `Số lượng ${item['SL']} vượt quá số lượng có sẵn trong vị trí "${item.Location}" (${selectedLocation.quantity}). Giới hạn tối đa: ${selectedLocation.quantity}`
        };
      }

      return { valid: true };
    },
    getAvailableLocationsFromFormatted(formattedString) {
      // Parse formatted string like "A28: 1 004\n2B: 1 000" into array of {name, quantity}
      if (!formattedString) return [];

      const locations = [];
      const lines = formattedString.split('\n');

      for (let line of lines) {
        line = line.trim();
        if (!line) continue;

        // Split by colon to get location and quantity
        if (line.includes(':')) {
          const parts = line.split(':');
          if (parts.length === 2) {
            const name = parts[0].trim();
            const quantityStr = parts[1].trim();
            // Remove spaces from quantity string: "1 004" => "1004"
            const quantity = parseInt(quantityStr.replace(/\s/g, ''), 10);

            if (!isNaN(quantity) && quantity > 0) {
              locations.push({ name, quantity });
            }
          }
        }
      }

      return locations;
    },
    getFilteredLocationOptions(item) {
      if (this.billType === 'import') {
        return this.locationOptions;
      }
      // Filter location options based on available locations in location_formatted
      if (!item || !item['Vị trí']) return [];

      const availableLocations = this.getAvailableLocationsFromFormatted(item['Vị trí']);
      const availableLocationNames = availableLocations.map(loc => loc.name);

      return this.locationOptions.filter(loc => availableLocationNames.includes(loc));
    },
    getMaxQuantityForLocation(item, location) {
      // Get max quantity allowed for selected location
      if (!item || !location) return 0;

      const availableLocations = this.getAvailableLocationsFromFormatted(item['Vị trí']);
      const selectedLoc = availableLocations.find(loc => loc.name === location);

      return selectedLoc ? selectedLoc.quantity : 0;
    },
    deleteMemoryAll() {
      // console.log('deleteMemoryAll')
      this.$request.post(`/api/repo/delmemoryall`).then(res=>{
        if(res.data.status === 'success'){
          this.billRecords = res.data.bill_data;
        }
      })
    },
    deleteMemorySelected() {
      const selectedItems = this.billRecords.filter(item => item.selection === true);
      // console.log('deleteMemorySelected')
      this.$request.post(`/api/repo/delmemory`, selectedItems).then(res=>{
        if(res.data.status === 'success'){
          this.billRecords = res.data.bill_data;
          this.deselectAllBill()
        }
      })
    },
    exportFile() {
      // console.log('exportFile')
      this.$swal.fire({
        title: "Xuất tệp danh mục linh kiện?",
        showDenyButton: false,
        showCancelButton: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.$request.post(`/api/repo/createbill`).then(res => {
            if (res.data.status === 'success' && res.data.filename) {
              this.downloadFile(res.data.filename);
            } else {
              this.$swal.fire({
                icon: "error",
                title: "Xuất tệp",
                text: "Xuất tệp lỗi: " + res.data.status,
              });
            }
          })
        }
      })
    },
    downloadFile(fileName) {
      // console.log('downloadFile', fileName)
      this.$request.get(`/api/repo/downloadbill/${fileName}`, { responseType: 'blob' })
        .then(response => {
          const fileURL = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = fileURL;
          link.download = fileName;
          link.click();
          window.URL.revokeObjectURL(fileURL);
          // document.body.removeChild(link); // Clean up
        })
        .catch(error => {
          console.error('Error downloading the file:', error);
        });
    },
    onInputChange(value) {
      // console.log('Selected value changed:', value.value, this.selectedOption)
      if(value) {
        this.criteria.component = value.value
      } else {
        this.criteria.component = "all"
      }
    },
    showAlertMessage(second, message) {
      this.dismissCountDown = Number(second);
      this.alertMessage = message;
      // console.log('showAlertMessage', message, second);
    },
    parseNumber(value) {
      if (!value) return 0;
      // Remove thousand separator dots
      const cleaned = typeof value === 'string' ? value.replace(/\./g, '').replace(/,/g, ' ').replace(/\s/g, '') : value;
      const num = parseFloat(cleaned);
      return isNaN(num) ? 0 : num;
    },
    handleQuantityInput(item, index, event) {
      const value = event.target.value;
      // Allow numbers, dots (thousand separator) and commas (decimal)
      const cleaned = value.replace(/[^\d,.\s]/g, '');
      item.SL = this.parseNumber(cleaned);
      // Keep input value in temporary storage
      this.$set(this.inputQuantityValues, index, value);
    },
    handleQuantityBlur(item, index, event) {
      // Update item.SL from current input value
      item.SL = this.parseNumber(this.inputQuantityValues[index] || 0);
      // Reformat when blur
      this.$set(this.inputQuantityValues, index, this.formatNumber(item.SL));
    },
    handleQuantityFocus(event) {
      // Select all on focus for easy input
      event.target.select();
    },
    handleModalQuantityFocus(event) {
      event.target.select();
    },
    formatLocationWithQuantity(value) {
      if (!value) return '';

      // Split by newline to handle multiple locations
      const lines = value.split('\n');

      return lines.map(line => {
        line = line.trim();
        if (!line) return '';

        // Check if line contains ":" (location: quantity format)
        if (line.includes(':')) {
          const parts = line.split(':');
          if (parts.length === 2) {
            const location = parts[0].trim();
            const quantity = parts[1].trim();
            // Format quantity with thousand delimiter
            return `${location}: ${this.formatNumber(quantity)}`;
          }
        }

        // If no colon or multiple colons, return line as is
        return line;
      }).join('\n');
    },
  },
  watch: {
    modalQuantityFormatted(newValue) {
      // Parse and update params.quantity
      this.params.quantity = this.parseNumber(newValue);
    },
    'params.quantity'(newValue) {
      // Format and update modalQuantityFormatted when params.quantity changes
      this.modalQuantityFormatted = this.formatNumber(newValue);
    }
  }
}
</script>

<style scoped>
.checkbox {
  width: 20px;
  height: 20px;
  margin: 0;
}

.qty-input {
  width: 80px; /* Max width for 4 characters */
  text-align: center;
  padding: 5px;
  font-size: 14px;
  border-radius: 4px;
  border: 1px solid #ccc;
}

.qty-input:focus {
  outline: none;
  border-color: #007bff;
}

.image-preview {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);
}

.preview-image {
  max-width: 500px;
  max-height: 500px;
}

/* Enable line breaks for table cells */
::v-deep td {
  white-space: pre-line;
}

/* Right align for number columns */
.text-right {
  text-align: right;
  padding-right: 10px;
}
</style>
